import { render, staticRenderFns } from "./modificaPraticaDettaglio.vue?vue&type=template&id=4418f60c&"
import script from "./modificaPraticaDettaglio.vue.ts?vue&type=script&lang=ts&"
export * from "./modificaPraticaDettaglio.vue.ts?vue&type=script&lang=ts&"
import style0 from "./modificaPraticaDettaglio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports